// Reference účastníků kurzů GAVITO technic s.r.o.
export const testimonials = [
  {
    text: "Lektorka úžasná, komunikace bezproblémová a přátelská k tomu. Kurz byl skvělý.",
    name: "Daniela G.",
    role: "účastnice kurzu",
    context: "Firemní vzdělávání",
  },
  {
    text: "Lektor měl profesionální a přátelský přístup, byl velmi trpělivý a s humorem se pokoušel naučit nás smysluplně využívat moderní nástroje umělé inteligence.",
    name: "Účastník kurzu",
    role: "pedagog",
    context: "Vzdělávací instituce",
  },
  {
    text: "Jsem nesmírně vděčná, že jsem do kurzu šla. Vedl ho příjemný, vždy nápomocný a klidný lektor. Naučila jsem se s Geminim, programem SUNO a Canvou. Tvoření materiálů do školky je pro mě nyní radost.",
    name: "Karolína V.",
    role: "učitelka MŠ",
    context: "Mateřská škola",
  },
  {
    text: "Lektor byl po celou dobu velmi profesionální, přístupný a ochotný. Dokázal obsah kurzu předávat srozumitelně, s nadšením a velkým přehledem. Největším přínosem pro mě bylo vysvětlení principů správného zadávání promptů a praktické ukázky.",
    name: "Bc. Zuzana K.",
    role: "učitelka MŠ",
    context: "Mateřská škola, Olomouc",
  },
  {
    text: "Přihlásila jsem kolegyně, které jsou spíše skeptické k práci na PC. To, co jim lektor předvedl, bylo prostě skvělé! Díky němu se podařilo vzbudit u pedagogů o práci s AI zájem.",
    name: "Ivana V.",
    role: "zástupkyně ředitele MŠ",
    context: "Mateřská škola",
  },
  {
    text: "Dokázal udržet naši pozornost celých 16 hodin online výuky, což se jen tak někomu nepodaří. Výklad byl jasný, k věci a díky vychytávkám a praktickým postřehům byla výuka zajímavá a inspirativní.",
    name: "Účastnice kurzu",
    role: "pedagog",
    context: "Online kurz AI",
  },
  {
    text: "Dnešní kurz je opravdu první pořádný impulz začít používat AI.",
    name: "Marta D.",
    role: "účastnice kurzu",
    context: "Firemní vzdělávání",
  },
  {
    text: "Velký dík oběma lektorkám za jejich výklad a trpělivost, s jakou informace předávaly. Celý kurz byl moc zajímavý, plný inspirace a nových informací.",
    name: "Mgr. Z. Š.",
    role: "ředitelka MŠ",
    context: "Mateřská škola",
  },
  {
    text: "Zpětná vazba od učitelů je výborná a všichni jsou motivováni k dalšímu vzdělávání. Lektor vedl kurz AI pro učitele odborně a zajímavě.",
    name: "Romana Š.",
    role: "ředitelka ZŠ",
    context: "Základní škola, Průhonice",
  },
  {
    text: "GPT je prostě zázrak, který určitě využiji. Bylo super, že lektor klasickou výuku prohloubil i o možnosti využití AI nejen pro pracovní věci, ale i pro osobní život.",
    name: "Účastnice kurzu",
    role: "pedagog",
    context: "Online kurz AI",
  },
];
